import { StyleSheet } from "react-native-unistyles";

import SNAP_PICKER_SPACING_STEP, {
  SNAP_PICKER_INSET_STEP,
} from "$src/core/constants/snap-picker";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  wrapper: {
    paddingVertical: spacing(1),
  },
  wrapperContent: {
    paddingHorizontal: spacing(SNAP_PICKER_INSET_STEP),
    gap: spacing(SNAP_PICKER_SPACING_STEP),
  },
}));

export default stylesheet;
